import { baseSplitApi } from "../../baseApi"
const StateTaxFormPath="/recruitment/state_tax_forms"


export const stateTaxFormApi = baseSplitApi.injectEndpoints({

    endpoints: (build) => ({
        getStateTaxForm: build.query({
            query: (state) => {
               
                return {
                    url:`${StateTaxFormPath}/${state}`,
                    method: 'GET'
                }
            },
           
         }),
         getAllStates: build.query({
            query: () => {
                
                return {
                    url:`${StateTaxFormPath}`,
                    method: 'GET'
                }
            },
           
         }),
     
       
    }),
    overrideExisting: false,
})
export const {useGetStateTaxFormQuery,useGetAllStatesQuery}=stateTaxFormApi